import React from "react";
import { useState, useEffect, useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ToastContainer,toast } from "react-toastify";
import Select from 'react-select'
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import { FormControlLabel, Checkbox } from "@mui/material";
import {  IconButton, Modal, Box, Dialog, DialogActions, DialogContent, DialogTitle,TextField, Grid, Card, CardContent, CardHeader } from '@mui/material';
import Table from 'react-bootstrap/Table';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Icon from "@mui/material/Icon";
import CloseIcon from '@mui/icons-material/Close';
import "layouts/style.css"
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { saveApprovalMatrix } from "assets/globalAPI/apiGlobal";
import { Pagination } from "react-bootstrap";
import { getAllUsers } from "assets/globalAPI/apiGlobal";
import { saveApprovalApprovalMatrixVendor } from "assets/globalAPI/apiGlobal";
import { fetchVendorMatrix } from "assets/globalAPI/apiGlobal";
import { fetchMaterialMatrix } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { fetchCustomerMatrix } from "assets/globalAPI/apiGlobal";
import { saveApprovalMatrixCustomer } from "assets/globalAPI/apiGlobal";
import { fetchEditable } from "assets/globalAPI/apiGlobal";
import { saveEditable } from "assets/globalAPI/apiGlobal";


const Editable=() => {
const toastId = React.useRef(null);
const navigate= useNavigate();

const [isActive, setIsActive] = useState(false);
const [selectedTab, setSelectedTab]= useState('vendor')

 const [formValues, setFormValues] = useState({
       trade_name: { value: '', error: false }, // Trade Name(as per gst)*
       address: { value: '', error: false }, // Address(as per GST)*
      //  street: { value: '', error: false }, // Address(to be registered as per GST)*
      //  house_no: { value: '', error: false }, // House No.
      //  city: { value: '', error: false }, // City*
      //  state: { value: '', error: false }, // State*
      //  pin_code: { value: '', error: false }, // Pin Code*
       type_of_firm: { value: '', error: false }, // Type of Firm/Company*
       cin: { value: '', error: false }, // CIN (if applicable)
       mca_roc_status: { value: '', error: false }, // MCA/ROC status (for Co/LLP)
       website: { value: '', error: false }, // Website
       proprietor_details: { value:'', error: false},
      //  proprietor_name: { value: '', error: false }, 
      //  proprietor_email: { value: '' , error: false}, 
      //  proprietor_mobile: { value: '' , error: false}, 
       pan: { value: '', error: false }, 
       gstn: { value: '',error: false }, // GSTN No*.
       contact_person_details: { value: '', error: false},
      //  contact_person: { value: '' , error: false}, // Name of Contact Person*
      //  contact_person_email: { value: '', error: false }, // Mobile Number*
      //  contact_person_mobile: { value: '', error: false },
      //  contact_telephone: { value: '', error: false }, 
      msme_details: { value: '', error: false },
      //  msme_registration_status: { value: '',error: false }, // MSME Registration Status.
      //  msme_registration_no: { value: '',error: false }, // MSME Registration no.
      //  msme_category: { value: '',error: false }, // MSME Category
      //  msme_type: { value: '',error: false }, // MSME Type
      fssai_details: { value: '', error: false },
      //  fssai_registration_status: { value: '',error: false }, // FSSI Registration Status.
      //  fssai_regn_no: { value: '',error: false }, // FSSI Regn No
      //  fssai_valid_till: { value: '',error: false }, // FSSI Valid Till (dd-mm-yyyy)
       tan: { value: '',error: false }, // TAN*
       itr_filing_status: { value: '',error: false }, // Status of filing ITR of last 2 yrs.
       pan_linked_aadhaar: { value: '',error: false }, // PAN linked with Aadhaar
       gst_turnover_prev_yr: { value: '',error: false }, // GST Turnover of Prev Yr.(Lakhs).
       e_invoice_applicable: { value: '',error: false }, // E-Invoice Applicable
       bank_details: { value: '',error: false }, // Bank Details
      //  bank_name: { value: '',error: false }, // Bank Name.
      //  ifsc_code: { value: '',error: false }, // IFSC Code
      //  bank_account_number: { value: '',error: false }, // Bank Account Number
      //  cheque_number: { value: '',error: false }, // Cheque Number
      //  cheque_issued_name: { value: '',error: false }, 
     });
     const expectedFields = {
        trade_name: 0,
        address: 0,
        // street: 0,
        // house_no: 0,
        // city: 0,
        // state: 0,
        // pin_code: 0,
        type_of_firm: 0,
        cin: 0,
        mca_roc_status: 0,
        website: 0,
        proprietor_name: 0,
        proprietor_email: 0,
        proprietor_mobile: 0,
        pan: 0,
        gstn: 0,
        contact_person: 0,
        contact_person_email: 0,
        contact_person_mobile: 0,
        contact_telephone: 0,
        msme_registration_status: 0,
        msme_registration_no: 0,
        msme_category: 0,
        msme_type: 0,
        fssai_registration_status: 0,
        fssai_regn_no: 0,
        fssai_valid_till: 0,
        tan: 0,
        itr_filing_status: 0,
        pan_linked_aadhaar: 0,
        gst_turnover_prev_yr: 0,
        e_invoice_applicable: 0,
        bank_details: 0,
        // bank_name: 0,
        // ifsc_code: 0,
        // bank_account_number: 0,
        // cheque_number: 0,
        // cheque_issued_name: 0,
      };
      

     const [checkboxStates, setCheckboxStates] = useState(() =>
        Object.keys(formValues).reduce((acc, key) => {
          acc[key] = 0;
          return acc;
        }, {})
      );
      

      const [formValues2, setFormValues2] = useState({
           firm_name: '',
           firm_status:'',
           address:'',
          //  street: '',
          //  po_box: '', 
          //  city: '',
          //  district_name: '',
          //  block_tehsil: '',
          //  main_town_village: '', 
          //  post_office: '', 
          //  police_station: '',
          //  state: '', // State*
          //  pin_code: '', // Pin Code*
          proprietor_details:'',
          //  proprietor_name: '', 
          //  proprietor_dob: '', 
          //  proprietor_email: '', 
          //  proprietor_mobile: '', 
          contact_person_details: '',
          // contact_person: '', 
          // contact_person_email: '', 
          // contact_person_mobile: '',
          // contact_person_telephone: '',
           pan: '', 
           aadhaar: '', 
           cin: '', 
           roc_status:'', 
           inpln: '', 
           mobile:'',
           email:'',
           fssai_details:'',
          //  fssi_registration_status: '', 
          //  fssi_regn_no: '', 
           gstn: '', 
           tan: '', 
           bank_details: '',
          //  bank_name: '',
          //  bank_branch_name: '',
          //  ifsc_code: '', // IFSC Code
          //  bank_account_number: '',
          //  undated_cheque_1: '',
          //  undated_cheque_2: '',
          //  undated_cheque_3: '',
          //  miscellaneous: '',
           companies: [
             { name_of_company: '', company_brand: '', monthly_turnover: '' }
           ],
           godown_details: '',
          //  godown_area: '',
          //  godown_type: '',
          //  rcc_structure: '',
          //  del_type_rickshaw:'',
          //  del_type_van:'',
          //  model_no_van:'',
          //  customer_salesman_1: '',
          //  customer_salesman_no_1: '',
          //  customer_salesman_2: '',
          //  customer_salesman_no_2: '',
          //  customer_weekoff: '',
     
           marketDetails: {
             Monday: [
               {
                 beatName_1: "",
                 distanceFromGodown_1: "",
                 expectedDailySales_1: "",
                 retailer_1: "",
                 wholesaler_1: "",
                 frequencyOfVisit_1: "",
                 readyStockOrOrderBooking_1: "",
                 beatName_2: "",
                 distanceFromGodown_2: "",
                 expectedDailySales_2: "",
                 retailer_2: "",
                 wholesaler_2: "",
                 frequencyOfVisit_2: "",
                 readyStockOrOrderBooking_2: ""
               }
             ],
             Tuesday: [
               {
                 beatName_1: "",
                 distanceFromGodown_1: "",
                 expectedDailySales_1: "",
                 retailer_1: "",
                 wholesaler_1: "",
                 frequencyOfVisit_1: "",
                 readyStockOrOrderBooking_1: "",
                 beatName_2: "",
                 distanceFromGodown_2: "",
                 expectedDailySales_2: "",
                 retailer_2: "",
                 wholesaler_2: "",
                 frequencyOfVisit_2: "",
                 readyStockOrOrderBooking_2: "",
               }
             ],
             Wednesday: [
               {
                 beatName_1: "",
                 distanceFromGodown_1: "",
                 expectedDailySales_1: "",
                 retailer_1: "",
                 wholesaler_1: "",
                 frequencyOfVisit_1: "",
                 readyStockOrOrderBooking_1: "",
                 beatName_2: "",
                 distanceFromGodown_2: "",
                 expectedDailySales_2: "",
                 retailer_2: "",
                 wholesaler_2: "",
                 frequencyOfVisit_2: "",
                 readyStockOrOrderBooking_2: "",
               }
              
             ],
             Thursday: [
               {
                 beatName_1: "",
                 distanceFromGodown_1: "",
                 expectedDailySales_1: "",
                 retailer_1: "",
                 wholesaler_1: "",
                 frequencyOfVisit_1: "",
                 readyStockOrOrderBooking_1: "",
                 beatName_2: "",
                 distanceFromGodown_2: "",
                 expectedDailySales_2: "",
                 retailer_2: "",
                 wholesaler_2: "",
                 frequencyOfVisit_2: "",
                 readyStockOrOrderBooking_2: "",
               },
             ],
             Friday: [
               {
                 beatName_1: "",
                 distanceFromGodown_1: "",
                 expectedDailySales_1: "",
                 retailer_1: "",
                 wholesaler_1: "",
                 frequencyOfVisit_1: "",
                 readyStockOrOrderBooking_1: "",
                 beatName_2: "",
                 distanceFromGodown_2: "",
                 expectedDailySales_2: "",
                 retailer_2: "",
                 wholesaler_2: "",
                 frequencyOfVisit_2: "",
                 readyStockOrOrderBooking_2: "",
               },
             ],
             Saturday: [
               {
                 beatName_1: "",
                 distanceFromGodown_1: "",
                 expectedDailySales_1: "",
                 retailer_1: "",
                 wholesaler_1: "",
                 frequencyOfVisit_1: "",
                 readyStockOrOrderBooking_1: "",
                 beatName_2: "",
                 distanceFromGodown_2: "",
                 expectedDailySales_2: "",
                 retailer_2: "",
                 wholesaler_2: "",
                 frequencyOfVisit_2: "",
                 readyStockOrOrderBooking_2: "",
               },
             ],
             Sunday: [
               {
                 beatName_1: "",
                 distanceFromGodown_1: "",
                 expectedDailySales_1: "",
                 retailer_1: "",
                 wholesaler_1: "",
                 frequencyOfVisit_1: "",
                 readyStockOrOrderBooking_1: "",
                 beatName_2: "",
                 distanceFromGodown_2: "",
                 expectedDailySales_2: "",
                 retailer_2: "",
                 wholesaler_2: "",
                 frequencyOfVisit_2: "",
                 readyStockOrOrderBooking_2: "",
               },
             ],
           },
         });

         const expectedFields2 = {
            firm_name: 0,
            firm_status: 0,
            address: 0,
            // street: 0,
            // po_box: 0,
            // city: 0,
            // district_name: 0,
            // block_tehsil: 0,
            // main_town_village: 0,
            // post_office: 0,
            // police_station: 0,
            // state: 0,
            // pin_code: 0,
            proprietor_details:'',
            // proprietor_name: 0,
            // proprietor_dob: 0,
            // proprietor_email: 0,
            // proprietor_mobile: 0,
            contact_person_details: '',
            // contact_person: 0,
            // contact_person_email: 0,
            // contact_person_mobile: 0,
            // contact_person_telephone: 0,
            pan: 0,
            aadhaar: 0,
            cin: 0,
            roc_status: 0,
            inpln: 0,
            mobile: 0,
            email: 0,
            fssai_details: 0,
            // fssi_registration_status: 0,
            // fssi_regn_no: 0,
            gstn: 0,
            tan: 0,
            bank_details: 0,
            // bank_name: 0,
            // bank_branch_name: 0,
            // ifsc_code: 0,
            // bank_account_number: 0,
            // undated_cheque_1: 0,
            // undated_cheque_2: 0,
            // undated_cheque_3: 0,
            // miscellaneous: 0,
            companies: 0,
            godown_details: 0,
            // godown_area: 0,
            // godown_type: 0,
            // rcc_structure: 0,
            // del_type_rickshaw: 0,
            // del_type_van: 0,
            // model_no_van: 0,
            // customer_salesman_1: 0,
            // customer_salesman_no_1: 0,
            // customer_salesman_2: 0,
            // customer_salesman_no_2: 0,
            // customer_weekoff: 0,
            marketDetails: 0
          };

          
         const [checkboxStates2, setCheckboxStates2] = useState(() =>
            Object.keys(formValues2).reduce((acc, key) => {
              acc[key] = 0;
              return acc;
            }, {})
          );

         const handleCheckboxChange = (key) => (event) => {
            setCheckboxStates((prev) => ({
              ...prev,
              [key]: event.target.checked ? 1 : 0,
              edit_for: 'vendor'
            }));
          };

          const handleCheckboxChange2 = (key) => (event) => {
            setCheckboxStates2((prev) => ({
              ...prev,
              [key]: event.target.checked ? 1 : 0,
              edit_for: 'customer'
            }));
          };

          const handleVendorSubmit=  async()=>{
            console.log("fields to edit>> ",checkboxStates)
            setIsActive(true);
            try{
                const response= await saveEditable(checkboxStates);
                const res= response.data;
                if(res.status){
                    setIsActive(false);
                    if(!toast.isActive(toastId.current)){
                        toastId.current= toast.success(res.message,{
                          className:"small-toast"
                        })
                      }
                      fetchAllEditableFields();
                }else{
                    setIsActive(false);
                    console.log("Could not save vendor edits",res);
                    if(!toast.isActive(toastId.current)){
                        toastId.current= toast.error(res.message,{
                          className:"small-toast"
                        })
                      }
                }
            }catch(error){
                setIsActive(false)
                console.log("error saving vendor edits configure>> ", err);
                if(!toast.isActive(toastId.current)){
                    toastId.current= toast.error(error.message,{
                      className:"small-toast"
                    })
                  }
                  if(error.response?.status==403){
                    if(!toast.isActive(toastId.current)){
                      toastId.current= toast.error("Your Session has expired",{
                        className:"small-toast"
                      })
                    }
                    setTimeout(()=>{
                      navigate("/")
                      localStorage.clear();
                    },2000)
                    return;
                  }
            }
          }

          const handleCustomerSubmit=  async()=>{
            console.log("fields to edit>> ",checkboxStates2)
            setIsActive(true);
            try{
                const response= await saveEditable(checkboxStates2);
                const res= response.data;
                if(res.status){
                    setIsActive(false);
                    if(!toast.isActive(toastId.current)){
                        toastId.current= toast.success(res.message,{
                          className:"small-toast"
                        })
                      }
                      fetchAllEditableFields();
                }else{
                    setIsActive(false);
                    console.log("Could not save vendor edits",res);
                    if(!toast.isActive(toastId.current)){
                        toastId.current= toast.error(res.message,{
                          className:"small-toast"
                        })
                      }
                }
            }catch(error){
                setIsActive(false)
                console.log("error saving customer edits configure>> ", err);
                if(!toast.isActive(toastId.current)){
                    toastId.current= toast.error(error.message,{
                      className:"small-toast"
                    })
                  }
                  if(error.response?.status==403){
                    if(!toast.isActive(toastId.current)){
                      toastId.current= toast.error("Your Session has expired",{
                        className:"small-toast"
                      })
                    }
                    setTimeout(()=>{
                      navigate("/")
                      localStorage.clear();
                    },2000)
                    return;
                  }
            }
          }

          useEffect(()=>{
            fetchAllEditableFields();
          },[selectedTab])


          const fetchAllEditableFields= async()=>{
            setIsActive(true);
            const body={
                module: selectedTab
            }
            console.log("body>> ", body)
            try{
                const response= await fetchEditable(body);
                const res= response.data;
                if(res.status){
                    setIsActive(false);
                    console.log("Editable fields response",res)
                    if(res.data){
                        if(selectedTab=="vendor"){

                            const fullState = Object.keys(expectedFields).reduce((acc, key) => {
                                acc[key] = res.data[key] ?? 0; // default to 0 if not in response
                                return acc;
                              }, { edit_for: 'vendor' });
                          
                              setCheckboxStates(fullState);
                        }else if(selectedTab=="customer"){
                            const fullState = Object.keys(expectedFields2).reduce((acc, key) => {
                                acc[key] = res.data[key] ?? 0; // default to 0 if not in response
                                return acc;
                              }, { edit_for: 'customer' });
                          
                              setCheckboxStates2(fullState);
                        }
                    }
                }else{
                    console.log("Could not fetch editable fields",res);
                    if(!toast.isActive(toastId.current)){
                        toastId.current= toast.error("Could Not fetch editable details",{
                          className:"small-toast"
                        })
                      }
                    setIsActive(false);
                }
            }catch(error){
                console.log("Error while fetching editable fields",error)
                setIsActive(false);
                if(!toast.isActive(toastId.current)){
                    toastId.current= toast.error(error.message,{
                      className:"small-toast"
                    })
                  }
                 if(error.response?.status==403){
                                            if(!toast.isActive(toastId.current)){
                                              toastId.current= toast.error("Your Session has expired",{
                                                className:"small-toast"
                                              })
                                            }
                                            setTimeout(()=>{
                                              navigate("/")
                                              localStorage.clear();
                                            },2000)
                                            return;
                                          }
                        }
          }

return(
    <DashboardLayout>
        <DashboardNavbar/>
        <ToastContainer/>
        <SimpleBackdrop openLoader={isActive}/> 
         <Tabs
                  defaultActiveKey="profile"
                  id="uncontrolled-tab-example"
                  className="mb-3"
                  activeKey={selectedTab}
                  onSelect={(k)=>{
                    
                    setSelectedTab(k)}}
                >
                    <Tab eventKey="vendor" title={<span style={{ fontSize: '15px', fontWeight: 'bold', color: '#FF0000' }}>Vendor</span>}>
                              <Card sx={{ mt: 3, boxShadow: 3, borderRadius: 2 }}>
                      <CardHeader title="Vendor Editable Fields" />
                      <CardContent>

                      <div className="container" style={{padding:'0px'}}>
                         <div className="checkbox-cards-container">
                                  {Object.keys(formValues).map((key) => {
                                   const formattedLabel = key
                                   .replace(/_/g, " ")
                                   .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
                                    return (
                                      <div key={key} className="checkbox-card">
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              sx={{ color: "#01040a" }}
                                              checked={checkboxStates[key] === 1}
                                            onChange={handleCheckboxChange(key)}
                                            />
                                          }
                                          label={<span className="checkbox-label">{formattedLabel}</span>}
                                        />
                                      </div>
                                    );
                                  })}
                                </div>
                          
                                <SoftButton
                                  variant="contained"
                                  sx={{ color: "ivory", marginTop: "30px" }}
                                  color="error"
                                  className="proceed-button"
                                  onClick={() => handleVendorSubmit()}
                                >
                                  Submit
                                </SoftButton>
                      </div>
                     
                      </CardContent>
                    </Card>
                              </Tab>

                              <Tab eventKey="customer" title={<span style={{ fontSize: '15px', fontWeight: 'bold', color: '#FF0000' }}>Customer</span>}>
                              <Card sx={{ mt: 3, boxShadow: 3, borderRadius: 2 }}>
                      <CardHeader title="Customer Editable Fields" />
                      <CardContent>

                      <div className="container" style={{padding:'0px'}}>
                         <div className="checkbox-cards-container">
                                  {Object.keys(formValues2).map((key) => {
                                   const formattedLabel =
                                   key === "marketDetails"
                                     ? "Market Details"
                                     : key
                                         .replace(/_/g, " ")
                                         .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
                                 
                                    return (
                                      <div key={key} className="checkbox-card">
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              sx={{ color: "#01040a" }}
                                              checked={checkboxStates2[key] === 1}
                                              onChange={handleCheckboxChange2(key)}
                                            />
                                          }
                                          label={<span className="checkbox-label">{formattedLabel}</span>}
                                        />
                                      </div>
                                    );
                                  })}
                                </div>
                          
                                <SoftButton
                                  variant="contained"
                                  sx={{ color: "ivory", marginTop: "30px" }}
                                  color="error"
                                  className="proceed-button"
                                  onClick={() => handleCustomerSubmit()}
                                >
                                  Submit
                                </SoftButton>
                      </div>
                     
                      </CardContent>
                    </Card>
                              </Tab>
                </Tabs>
    </DashboardLayout>
)
}

export default Editable;